import { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { supabase } from "../lib/supabase";

function VendorDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const shopFromState = location.state?.shop || null;
  const shopIdFromQuery = searchParams.get("shopId");

  const [shop, setShop] = useState(shopFromState);
  const [loading, setLoading] = useState(!shopFromState && !!shopIdFromQuery);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const fetchShop = async () => {
      if (shopFromState || !shopIdFromQuery) return;

      try {
        setLoading(true);

        const { data, error } = await supabase
          .from("shops")
          .select(`
            *,
            shop_owners (
              id,
              business_name,
              average_rating
            )
          `)
          .eq("id", shopIdFromQuery)
          .maybeSingle();

        if (error) throw error;

        if (!data) {
          setErrorMessage("Shop not found.");
          return;
        }

        setShop(data);
      } catch (error) {
        console.error("Fetch vendor details error:", error);
        setErrorMessage(error.message || "Failed to load shop.");
      } finally {
        setLoading(false);
      }
    };

    fetchShop();
  }, [shopFromState, shopIdFromQuery]);

  if (loading) {
    return (
      <div style={page}>
        <div style={card}>
          <h1>Loading shop...</h1>
        </div>
      </div>
    );
  }

  if (!shop) {
    return (
      <div style={page}>
        <div style={card}>
          <h1>{errorMessage || "No shop selected"}</h1>
          <button onClick={() => navigate("/shops")} style={solidBtn}>
            Back to Shops
          </button>
        </div>
      </div>
    );
  }

  const rating = Number(
    shop.rating || shop.shop_owners?.average_rating || 0
  ).toFixed(1);

  const shopName = shop.shop_name || shop.shop_owners?.business_name || "Shop";

  return (
    <div style={page}>
      <button onClick={() => navigate(-1)} style={backBtn}>
        Back
      </button>

      <div style={card}>
        <h1 style={{ marginTop: 0 }}>{shopName}</h1>
        <p style={{ color: "#d1d1d1" }}>Material Supplier</p>

        <div style={detailsGrid}>
          <p><strong>Location:</strong> {shop.city || "N/A"}</p>
          <p>
            <strong>Address:</strong>{" "}
            {[shop.flat_house_no, shop.street_area, shop.city, shop.state, shop.country, shop.pincode]
              .filter(Boolean)
              .join(", ") || "N/A"}
          </p>
          <p><strong>Rating:</strong> {rating} ⭐</p>
          <p><strong>Contact:</strong> {shop.contact_phone || "Not added yet"}</p>
          <p><strong>Open:</strong> {shop.open_hours || "Not added yet"}</p>
        </div>

        <div style={aboutBox}>
          <h3 style={{ marginTop: 0 }}>About Shop</h3>
          <p style={{ marginBottom: 0, color: "#d1d1d1" }}>
            {shopName} supplies verified materials with platform-linked fulfillment and delivery tracking.
          </p>
        </div>

        <button
          onClick={() => alert(`Contact request sent to ${shopName}`)}
          style={solidBtn}
        >
          Contact Shop
        </button>
      </div>
    </div>
  );
}

const page = {
  padding: "40px",
  fontFamily: "Arial, sans-serif",
  maxWidth: "900px",
  margin: "0 auto",
  background: "#000",
  color: "#fff",
  minHeight: "100vh",
};

const card = {
  background: "#111",
  padding: "30px",
  borderRadius: "18px",
  boxShadow: "0 4px 18px rgba(0,0,0,0.18)",
  border: "1px solid #222",
};

const detailsGrid = {
  marginTop: "24px",
  display: "grid",
  gap: "12px",
};

const aboutBox = {
  marginTop: "24px",
  background: "#0b0b0b",
  padding: "18px",
  borderRadius: "12px",
  border: "1px solid #222",
};

const backBtn = {
  marginBottom: "20px",
  padding: "10px 16px",
  border: "1px solid #444",
  background: "#111",
  color: "#fff",
  borderRadius: "10px",
  cursor: "pointer",
};

const solidBtn = {
  marginTop: "24px",
  padding: "12px 20px",
  border: "none",
  background: "#fff",
  color: "#000",
  borderRadius: "10px",
  cursor: "pointer",
  fontWeight: "bold",
};

export default VendorDetails;
